import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { t } from '../common/LocalizationProvider';
import {makeStyles} from "@material-ui/core";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
}));

 const  FormDialog = ({refreshGeofences, open,handleClose,newItem , setNewItem}) => {
     const classes = useStyles();

     const handleChange = (e) => {
         setNewItem({...newItem, name: e.target.value}) ;
     }

     const handleAdd = async () => {
         if (!newItem.name?.trim()) return;

         const response = await fetch('/api/geofences', {
             method: 'POST',
             headers: {'Content-Type': 'application/json'},
             body: JSON.stringify(newItem),
         });
         if (response.ok) {
             await handleClose();
             refreshGeofences()
         }
     }

    return (
        <div>
            <Dialog classes={{ paper: classes.paperRemoveDialog }} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{t('geofenceRegion')}</DialogTitle>

                <DialogContent>
                    <DialogContentText className={classes.dialogMessage}>
                        {t('regionNameInstruction')}
                    </DialogContentText>
                    <TextField
                        className={classes.neonInput}
                        autoFocus
                        margin="dense"
                        id="name"
                        label={t('geofenceName')}
                        type="email"
                        fullWidth
                        onChange={handleChange}
                    />
                </DialogContent>

                <DialogActions className={classes.actions}>
                    <Button className={`${classes.cyberButtonRemoveDialog} ${classes.cancelButtonRemoveDialog}`} variant='outlined' onClick={handleClose}>
                        {t('sharedCancel')}
                    </Button>
                    <Button className={`${classes.cyberButtonRemoveDialog} ${classes.saveButtonRemoveDialog}`} variant='outlined' onClick={handleAdd}>
                        {t('sharedSave')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export { FormDialog };
